import moment from "moment";
import React, { useState } from "react";
import Select from "react-select";
import { Progress, Card, Row, Statistic, Dropdown, Menu, DatePicker } from "antd";
import { Link, Switch, Route, useHistory, useParams } from "react-router-dom";
import Creatable from "react-select/creatable";
import { useSelector } from "react-redux";
import Receive from "../../components/reusable/receive";
import { usePet, useListData, presets, useToggle, stringifyDate } from "../../modules";

import NewUser from "../../components/modals/newuser";
import EditUser from "../../components/modals/edituser";

import {
  AiOutlineDown,
  AiOutlineReload,
  AiOutlineBarChart,
  AiOutlineEllipsis,
  AiOutlineArrowUp,
} from "react-icons/ai";
import {
  FaClipboardCheck,
  FaArrowLeft,
} from "react-icons/fa";

const {RangePicker} = DatePicker

const DashboardCard = ({statValue, name, pMonth, suffix, bgColor, statName, marginRight, Icon}) => {
  return (
    <Card
      hoverable
      style={{
        position: "relative",
        width: 300,
        height: 130,
        borderRadius: 10,
        backgroundColor: bgColor,
        marginRight: marginRight,
      }}
    >
      <h4 className="flex items-center space-x-2 text-gray-800">
        <Icon style={{ fontSize: 20 }} />
        <span>{name}</span>
        <Dropdown
          className="ml-60"
          overlay={
            <Menu>
              <Menu.Item>Filter</Menu.Item>
              <Menu.Item>Breakdown</Menu.Item>
              <Menu.Item>Export</Menu.Item>
            </Menu>
          }
        >
          <a
            className="ant-dropdown-link"
            onClick={(e) => e.preventDefault()}
            style={{ position: "absolute", right: 10, top: 20 }}
          >
            <AiOutlineEllipsis style={{ fontSize: 20, color: "black" }} />
          </a>
        </Dropdown>
      </h4>

      <Row>
        <Statistic
          title={statName}
          valueStyle={{ color: "#FFFFFF" }}
          style={{ marginRight: 70 }}
          value={statValue}
          suffix={suffix}
        />
        <Statistic
          title="Past Month"
          value={pMonth}
          precision={1}
          valueStyle={{ color: "#3f8600" }}
          prefix={<AiOutlineArrowUp />}
          suffix="%"
        />
      </Row>
    </Card>
  );
}

const Dashboard = () => {
  const [ranges, setRanges] = useState([
    moment().startOf("day"),
    moment().endOf("day"),
  ]);
  const [selected, setSelected] = useState();
  const [chosen, setChosen] = useState();
  const [string, setString] = useState()
  const [role, setRole] = useState();
  const [totalEmployees, setTotalEmployees] = useState(30)
  const [average, setAverage] = useState(40)
  const [totalLeaveReq, setTotalLeaveReq] = useState(10)
  const [totalPer, setTotalPer] = useState(20)
  const [averagePer, setAveragePer] = useState(50);
  const [leavePer, setLeavePer] = useState(5);
  const [cards, setCards] = useState([
    {
      name: "Total",
      stat: totalEmployees,
      statName: "Empoyees",
      pastMonth: totalPer,
      suffix: " ",
      bgColor: "#18A375",
      marginRight: 22,
      icon: AiOutlineBarChart,
    },
    {
      name: "Attendance",
      stat: average,
      statName: "Average",
      pastMonth: averagePer,
      suffix: "%",
      bgColor: "#18A375",
      marginRight: 22,
      icon: FaClipboardCheck,
    },
    {
      name: "Leave Requests",
      stat: totalLeaveReq,
      statName: "Total",
      pastMonth: leavePer,
      suffix: " ",
      bgColor: "#18A375",
      marginRight: 0,
      icon: FaArrowLeft,
    },
  ]);

  const [newUserModal, toggleNewUserModal] = useToggle();
  const [userModal, toggleUserModal] = useToggle();

   const select = (usr) => {
     setSelected(usr);
     toggleUserModal();
   };
  
  const selectRange = (range) => {
    setRanges(range);
  };

  const [
        { loading: rLoading, error: rError, fetch: rFetch }, 
        { list: roles }, 
    ] = useListData('roles', { string, limit: 100 }, { notify: true, manual: false })
  
  const [
    { loading, error, fetch: fetchEmployees },
    { list: employees },
    { navigate, Paginate, page = 1, limit = 10 },
  ] = useListData(
    "allEmployees",
    { string },
    { notify: true, manual: false },
    "employees"
    );
  
  const refresh = () => {
    navigate(1);
    fetchEmployees();
  };

    const search = str => {
        setString(str)
        navigate(1)
        fetch()
    }
    
    const onComplete = ({ data }, notif, ops) => {
        notif(`Account has been ${selected?.active ? 'deactivated' : 'activated' }`, ops('success'))        
        fetch()
    }

    const [, execute] = usePet('toggleActive', { id: selected?._id }, { notify: true, callback: onComplete, manual: true })

    const toggleActive = usr => {
        setSelected(usr)
        execute()        
    }

    
    return (
      <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
        <div className="px-6 sm:px-8 lg:px-10 py-5 max-w-8xl mx-auto my-auto bg-white">
          <div>
            <Row
              gutter={20}
              justify="center"
              style={{ flex: "auto", justifyContent: "center" }}
            >
              {cards.map((card) => (
                <DashboardCard
                  name={card.name}
                  statName={card.statName}
                  statValue={card.stat}
                  pMonth={card.pastMonth}
                  bgColor={card.bgColor}
                  suffix={card.suffix}
                  marginRight={card.marginRight}
                  Icon={card.icon}
                />
              ))}
            </Row>
          </div>
        </div>
        {newUserModal && (
          <NewUser
            onPerform={fetch}
            toggle={toggleNewUserModal}
            visible={newUserModal}
          />
        )}

        {userModal && (
          <EditUser
            onPerform={fetch}
            user={selected}
            toggle={toggleUserModal}
            visible={userModal}
          />
        )}
        <div className="sm:flex sm:justify-between sm:items-center mt-12 mb-8">
          <input
            onChange={(e) => search(e.target.value)}
            className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
            id="grid-search"
            type="text"
            placeholder="Employee Name."
          />
          <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
            <RangePicker
              value={ranges}
              onChange={selectRange}
              ranges={presets}
            />
            <button
              onClick={refresh}
              className="btn ml-2 py-3 hisani-btn-green-light text-white"
            >
              <AiOutlineReload style={{ color: "white" }} />
            </button>
            <Dropdown
              overlay={
                <Menu>
                  <Menu.Item onClick={() => null}>Employee List </Menu.Item>
                </Menu>
              }
            >
              <button className="btn hisani-btn-green-light text-white">
                <span className="hidden xs:block mr-2">Reports</span>
                <AiOutlineDown />
              </button>
            </Dropdown>
          </div>
        </div>

        <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
          <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
            <h2 className="font-semibold text-gray-800">Employees</h2>
            <Receive error={rError} loading={rLoading} progress>
              <Select
                isClearable
                value={role}
                onChange={setRole}
                styles={{
                  input: (styles) => ({ ...styles, minWidth: "10em" }),
                }}
                options={roles?.map((role) => ({
                  label: role.name,
                  value: role._id,
                }))}
                placeholder="Select Role"
              />
            </Receive>
          </header>
          <div className="p-3">
            {/* Table */}
            <div className="overflow-x-auto">
              <Receive error={error} loading={loading} progress>
                {employees.length > 0 ? (
                  <table className="table-auto w-full">
                    {/* Table header */}
                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                      <tr>
                        <th className="p-2">
                          <div className="font-semibold text-center">No</div>
                        </th>
                        <th className="p-2">
                          <div className="font-semibold text-left">Name</div>
                        </th>
                        <th className="p-2">
                          <div className="font-semibold text-center">
                            Status
                          </div>
                        </th>
                        <th className="p-2">
                          <div className="font-semibold text-center">Date</div>
                        </th>
                        <th className="p-2">
                          <div className="font-semibold text-center"></div>
                        </th>
                      </tr>
                    </thead>
                    {/* Table body */}
                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                      {/* Row */}
                      {employees.map((emp, key) => (
                        <tr>
                          <td className="p-2">
                            <div className="text-center">
                              {(page - 1) * limit + key + 1}.
                            </div>
                          </td>
                          <td className="p-2">
                            <div className="">{emp.name}</div>
                          </td>
                          <td className="p-2">
                            <div
                              className={`text-center ${
                                emp.status ? "text-green-500" : "text-gray-700"
                              }`}
                            >
                              {emp.status ? "Active" : "Inactive"}
                            </div>
                          </td>
                          <td className="p-2">
                            <div className="text-center">
                              {stringifyDate(emp.hireDate)}
                            </div>
                          </td>
                          <td className="p-2 text-center">
                            <Dropdown
                              overlay={
                                <Menu>
                                  <Menu.Item onClick={() => select(emp)}>
                                    View
                                  </Menu.Item>
                                  <Menu.Item onClick={() => toggleActive(emp)}>
                                    {emp.active ? "Deactivate" : "Activate"}
                                  </Menu.Item>
                                </Menu>
                              }
                            >
                              <a
                                className="ant-dropdown-link flex items-center h-10"
                                onClick={(e) => e.preventDefault()}
                              >
                                <span className="mr-2">Actions</span>{" "}
                                <AiOutlineDown />
                              </a>
                            </Dropdown>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="w-full h-16 flex items-center justify-center">
                    <p className="font-semibold text-base">
                      Please click above to add a new user
                    </p>
                  </div>
                )}
              </Receive>
              {Paginate}
            </div>
          </div>
        </div>
      </div>
    );
}

export default Dashboard